// extracted by mini-css-extract-plugin
module.exports = {"divisor":"style_divisor__1Btat","container":"style_container__vdyxE"};